import twinpeakrealtorsConfig from './tenants/twinpeakrealtors'
import type { TenantConfig, TenantId } from './types'
import multigenesysConfig from './tenants/multigenesys'

const tenantMap: Record<TenantId, TenantConfig> = {
  twinpeakrealtors: twinpeakrealtorsConfig,
  multigenesys: multigenesysConfig
}

// Fail-safe default: the production deployment's tenant. A build with a
// missing REACT_APP_TENANT must never ship another tenant's branding.
const tenantId = (process.env.REACT_APP_TENANT as TenantId) || 'twinpeakrealtors'

if (!tenantMap[tenantId]) {
  throw new Error(
    `Unknown tenant "${tenantId}". Valid tenants: ${Object.keys(tenantMap).join(', ')}`
  )
}

const tenantConfig: TenantConfig = tenantMap[tenantId]

export default tenantConfig
export type {
  PoweredBy,
  TenantColors,
  TenantConfig,
  TenantDarkTheme,
  TenantId,
  TenantSeedTheme,
  TenantTheme
} from './types'
